import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useDaily, useLocalSessionId, useWaitingParticipants } from '@daily-co/daily-react';
//Recoil系
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { userTypeAtom, playAudioAtom } from '../../State';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

export default function AutoplayDialog({ roomID, userType }) {
  //Recoil系
  const userTypeState = useRecoilValue(userTypeAtom);
  const setPlayAudioState = useSetRecoilState(playAudioAtom);
  const { t } = useTranslation();
  //その他
  const [isShownState, setIsShownState] = useState(false);

  //読み込み時初回処理
  useEffect(() => {}, []);

  //クリック
  const clickok = async (e) => {
    setPlayAudioState(true);
    setIsShownState(true);
  };

  //レンダービュー
  return (
    <>
      {isShownState == false && isMobile && userType == 'viewer' && (
        <>
          <div id="backoverlay"></div>
          <div id="autoplayDialog">
            {/* <img src="https://d2wp3sepl8g4xv.cloudfront.net/hp/images/logo.png" alt="Photo" /> */}

            <h1>{t("call.You're joining as a viewer")}</h1>
            <span>{t('call.Your mic will remain off.')}</span>
            <button id="notSupportedButton" onClick={clickok}>
              OK
            </button>
          </div>
        </>
      )}
    </>
  );
}
